import React from 'react';
import LinkBase, { type TLinkBase } from './LinkBase';

const StandAloneLink = (props: Omit<TLinkBase, 'kind'>) => <LinkBase {...props} kind="standalone" />;

export default StandAloneLink;
